module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-BoldItalic.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-BoldItalic.eot
// module id = 10
// module chunks = 8